import React from 'react';

function NotFound(props) {
    return (
        <div className="contenedorHome">
            <br/>
            <div className="row">
                <div className="col-md-12">
                     No se ha encontrado el recurso!
                </div>
            </div> 
        </div>

    );
}

export default NotFound;